var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { cols: "5" } },
        [
          _c("ContractSummary", {
            staticClass: "mt-2",
            attrs: {
              contract: _vm.contract,
              contractCategories: _vm.contractCategories
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "7" } }, [
        _vm.addressText
          ? _c("p", { staticClass: "text-muted mt-2" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("message.contractAddressDetails.question")) +
                  " "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.addressText
          ? _c("p", { staticClass: "text-muted mt-2" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("message.contractAddressDetails.noAddressHint")
                  ) +
                  " "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex flex-wrap" },
          _vm._l(_vm.addresses, function(address) {
            return _c(
              "b-btn",
              {
                key: address.id,
                staticClass: "hoverIE p-0 my-2 mr-4 rounded-0 btn-address",
                attrs: { variant: "transparent" },
                on: {
                  click: function($event) {
                    _vm.onSelectAddressbox(address)
                  }
                }
              },
              [
                _c(
                  "Infobox",
                  {
                    class: _vm.getAddressBoxClass(address),
                    attrs: {
                      title: _vm.getTitle(address),
                      subtitle: address.postalCode + " " + address.city
                    }
                  },
                  [_c("span", { staticClass: "infobox-icon ti-home" })]
                )
              ],
              1
            )
          })
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59888284", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59888284","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contracts/ContractAddressDetails.vue
// module id = srJP
// module chunks = 1